import styled from "styled-components";

const A = styled.a`
  font-size:${(props)=>props.theme.fontSizeDefault};
  font-family:${(props)=>props.theme.gilroyFontFamilyMedium};
  color:${(props)=>props.theme.colorBlack};
`;

export default A;
